import s from './membership.Style';
import { styled } from 'styled-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';

const Free = () => {
  return (
    <s.Container>
      <s.Div>
        <s.Top>
          <s.Title>Free</s.Title>
          <s.Comment>
            가입만 하면 누구나 이용 가능
            <br />
            땅집고옥션 회원이 되어 경공매 전략을 세워보세요
          </s.Comment>
        </s.Top>
        <s.Row style={{ fontSize: '28px' }}>무료</s.Row>
      </s.Div>
      <s.BenefitList>
        <s.Row style={{ gap: '0px', fontSize: '16px' }}>
          <span style={{ color: '#008AFF' }}>무료 제공</span>
        </s.Row>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>경공매 종합검색</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>지도 검색</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>경매 일정별 검색</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>지역 기반 검색</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>특수·테마 물건 검색</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>스탠다드 전국구 멤버십 5일 무료 체험</span>
        </s.Benefit>
      </s.BenefitList>
    </s.Container>
  );
};

export default Free;
